// help-center-image.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface HelpCenterImageUploadResponse {
  sn: string;
  url: string;
  fileName: string;
  fileSize: string;
}

@Injectable({
  providedIn: 'root'
})
export class HelpCenterImageService {
  private apiUrl = `${environment.customerserviceApiUrl}/HelpCenterImage/images`;

  constructor(private http: HttpClient) {}

  uploadImage(file: File, permissionCode?: string): Observable<HelpCenterImageUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    if (permissionCode) {
      formData.append('permissionCode', permissionCode);
    }

    return this.http.post<HelpCenterImageUploadResponse>(`${this.apiUrl}/upload`, formData);
  }

  getImageUrl(sn: string): string {
    return `${this.apiUrl}/${sn}`;
  }

  resolveImageRequestUrl(rawUrl: string): string {
    if (!rawUrl) {
      return rawUrl;
    }

    if (rawUrl.startsWith('http')) {
      return rawUrl;
    }

    const sn = this.extractImageSn(rawUrl);
    if (sn) {
      return this.getImageUrl(sn);
    }

    return rawUrl;
  }

  private extractImageSn(url: string): string | null {
    const match = url.match(/\/images\/([0-9a-fA-F-]{36})(?:$|[/?#])/);
    return match?.[1] || null;
  }

  deleteImage(sn: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${sn}`);
  }
}
